import { render } from "./SuggestionManagerProps.vue?vue&type=template&id=49a5732f"
import script from "./SuggestionManagerProps.vue?vue&type=script&lang=js"
export * from "./SuggestionManagerProps.vue?vue&type=script&lang=js"

import "./SuggestionManagerProps.vue?vue&type=style&index=0&id=49a5732f&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__